<script>
import { mapState } from 'pinia';

import { useUserStore } from '../../../../store/useUserStore.js';

export default {
  name: 'CpYourActivity',
  components: {
    CpButton: require('../../button').default,
    CpButtonLink: require('../../button-link').default,
    CpGrid: require('../../grid').default,
    CpGridItem: require('../../grid-item').default,
    CpBox: require('../../box').default,
    CpBoxContent: require('../../box-content').default,
    CpPageContent: require('../../page-content.vue').default,
    CpSliceToggle: require('../../inputs/SliceToggle').default,
    VueSimpleSpinner: require('../../vue-simple-spinner').default,
    InfiniteLoading: require('vue-infinite-loading').default,
    CpActivityCard: require('./ActivivityCard').default,
    capitalizeWords: require('../../mixins/utils.js').default,
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginTop: require('../../directives/margins').marginTop,
    marginRight: require('../../directives/margins').marginRight,
    marginBottom: require('../../directives/margins').marginBottom,
    marginLeft: require('../../directives/margins').marginLeft,
  },
  props: {
    user: Object,
    loading: {
      type: Boolean,
      default: false,
    },
    activities: {
      type: Array,
      default: () => [],
    },
    getActivities: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      userName: this.capitalizeWords(this.user.first_name) ?? '',
    };
  },
  computed: {
    isViewingSelf() {
      return this.isUserLogin && this.userLoginData.id === Number(this.user.id);
    },
    ...mapState(useUserStore, ['isUserLogin', 'userLoginData']),
  },
  methods: {
    infiniteHandler($state) {
      this.getActivities($state);
    },
  },
};
</script>

<template>
  <div class="activityContainer">
    <div style="min-height: 200px">
      <transition-group name="feed-fade">
        <CpActivityCard
          v-for="(item, index) in activities"
          :key="item.id"
          :index="index"
          :item="{ ...item, post_type: item.post_type ? item.post_type : 'lobby' }"
        />
      </transition-group>
      <transition name="feed-fade">
        <infinite-loading ref="infiniteLoading" @infinite="infiniteHandler" v-margin="1">
          <div slot="spinner">
            <div class="heading-4"><vue-simple-spinner v-margin="1" />Loading more...</div>
          </div>
          <div slot="no-more">
            <div class="heading-4"></div>
          </div>
          <div slot="no-results" class="noResults">
            <div class="noResultsContainer">
              <h3 class="subheadline1 primaryColor">There are no items on {{ isViewingSelf ? 'your' : userName + "'s" }} public profile.</h3>
            </div>
          </div>
        </infinite-loading>
      </transition>
    </div>
  </div>
</template>

<style scoped>
.activityContainer {
  margin-bottom: 50px;
}

.noResults {
  display: flex;
  justify-content: center;
  margin: 50px 0;
}

.noResultsContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #f47457;
  background-color: #f3f3f3;
  width: 75%;
  padding: 1em 0;
}

@media screen and (max-width: 414px) {
  .noResultsContainer {
    width: 100%;
  }
}
</style>
